import React from "react";
import { useLocalStorage } from "@uidotdev/usehooks";
import { ReactComponent as GoogleDriveIcon } from "../../../static/icons/google-drive.svg";
import { localStorageKeys } from "../../../lib/local-storage-keys";
import { useGoogleDriveStatus } from "../../../data/queries/use-google-drive-settings";
import { useGoogleDriveConnectFlow } from "../../../data/hooks/use-google-drive-connect-flow";
import { GoogleDriveConnectDialog } from "./google-drive-connect-dialog";
import { Button } from "../../ui/button";

export function GoogleDriveChatBanner() {
    const { data: status, isLoading } = useGoogleDriveStatus();
    const [dismissed, setDismissed] = useLocalStorage<boolean>(localStorageKeys.googleDriveChatBannerDismissed, false);
    const connectFlow = useGoogleDriveConnectFlow();

    if (isLoading || dismissed || status?.connected) return null;

    return (
        <>
            <div className="mx-auto mb-4 w-full max-w-2xl rounded-lg border bg-muted/50 p-4">
                <div className="flex items-start gap-3">
                    <GoogleDriveIcon className="mt-0.5 h-5 w-5 shrink-0" />
                    <div className="flex flex-col gap-2">
                        <p className="text-sm font-medium">Your work is already in Drive — bring it here</p>
                        <p className="text-xs text-muted-foreground">
                            Connect Google Drive and Tekkr will surface relevant files as you type. You always choose
                            exactly what gets included.
                        </p>
                        <div className="flex items-center gap-3">
                            <Button size="sm" onClick={connectFlow.openDialog}>
                                Connect Google Drive
                            </Button>
                            <button
                                onClick={() => setDismissed(true)}
                                className="text-xs text-muted-foreground transition-colors hover:text-foreground"
                            >
                                Maybe later
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <GoogleDriveConnectDialog
                open={connectFlow.dialogOpen}
                onOpenChange={connectFlow.setDialogOpen}
                storageLevel={connectFlow.storageLevel}
                onStorageLevelChange={connectFlow.setStorageLevel}
                accessMode={connectFlow.accessMode}
                onAccessModeChange={connectFlow.setAccessMode}
                onConnect={connectFlow.connect}
                connecting={connectFlow.connecting}
                isPending={connectFlow.isPending}
                success={connectFlow.success}
                canConnect={connectFlow.canConnect}
            />
        </>
    );
}
